var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirplaneBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.708,
    height: 19.664,
    viewBox: "0 0 35.708 19.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "airplane",
    d: "M2.781,6.4a.733.733,0,0,1,.686.039L8.1,9.257a.732.732,0,0,0,.708.029L23.17,2.079A15.006,15.006,0,0,1,31.539.037s3.384-.357,3.02,2.035c-.35,2.3-7.853,5.478-10.148,6.143a.706.706,0,0,0-.4.3l-4.684,7.336a.721.721,0,0,1-.347.285l-2.839,1.1a.725.725,0,0,1-.989-.624l-.238-3.885a.725.725,0,0,0-.983-.626c-2.108.8-7.447,2.62-12.01,2.617-.521,0,.582-1.3,1.244-2.026a.71.71,0,0,0-.013-.97L.2,8.629A.714.714,0,0,1,.419,7.486Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 0, 2.413)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneBlack);
export default __webpack_public_path__ + "static/media/airplane-black.e0c1062825a7083ea224d6632903f554.svg";
export { ForwardRef as ReactComponent };